import type { FaultReportUpdateShape } from 'Services/SalesManagement/Features/FaultReport/faultReportSlice'
import { datetimeFormatter } from 'Util/formatters'
import Theme from 'Util/theme'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import EditIcon from '@mui/icons-material/Edit'
import ReportProblemIcon from '@mui/icons-material/ReportProblem'
import { IconButton, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import { styled } from '@mui/material/styles'
import type { FC } from 'react'
import { t } from 'ttag'

const StyledListItemIcon = styled(ListItemIcon)(() => ({
  minWidth: 35
}))

const FaultReportUpdate: FC<{
  faultReportUpdate: FaultReportUpdateShape
  handleEdit: () => void
  handleDelete: () => void
  canControl: boolean
}> = ({ faultReportUpdate, handleEdit, handleDelete, canControl }) => {
  return (
    <ListItem sx={{ backgroundColor: 'background.paper', my: 1 }}>
      <StyledListItemIcon>
        <ReportProblemIcon fontSize="small" sx={{ color: Theme.palette.info.main }} />
      </StyledListItemIcon>
      <ListItemText
        primary={faultReportUpdate.description_fi}
        secondary={datetimeFormatter(faultReportUpdate.updated)}
      />
      <>
        {canControl && (
          <>
            <IconButton onClick={handleEdit} aria-label={t`Edit fault report update`}>
              <EditIcon sx={{ color: Theme.palette.tertiary.main }} />
            </IconButton>
            <IconButton onClick={handleDelete} aria-label={t`Delete fault report update`}>
              <DeleteForeverIcon color="error" />
            </IconButton>
          </>
        )}
      </>
    </ListItem>
  )
}

export { FaultReportUpdate }
